import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $j from 'jquery';

import windowResize from '../../../../helper/WindowResize';

class CollapseableGroup extends Component {
  static childContextTypes = {
    changeMyState: PropTypes.func,
    getHeight: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: props.startIndex
    };

    this.collapseableGroupRef = React.createRef();
  }

  state = {
    activeIndex: 2
  };

  getChildContext() {
    return {
      changeMyState: this.changeMyState,
      getHeight: this.getHeight
    };
  }

  componentDidMount() {
    this.contentHeight = this.getHeight();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.windowHeight !== this.props.windowHeight) {
      this.contentHeight = this.getHeight();
    }
  }

  getHeight = () => {
    const node = this.collapseableGroupRef.current;
    const headers = $j(node).find('.collapsableHeader');
    let headersHeight = 0;
    headers.each((i, e) => (headersHeight += $j(e).outerHeight()));
    return $j(window).height() - (node.offsetTop + headersHeight);
  };

  changeMyState = (collapse, index) => {
    if (!collapse) {
      this.setState({ activeIndex: index });
    } else {
      this.setState({
        activeIndex: 0
      });
    }
  };

  getClonedChild = (child, index) =>
    child
      ? React.cloneElement(child, {
          activeIndex: this.state.activeIndex,
          index: index + 1,
          contentMaxHeight: this.contentHeight
        })
      : null;

  render() {
    const { children } = this.props;
    const childrenWithProps = React.Children.map(children, this.getClonedChild);
    return (
      <div className="CollapsableGroup" ref={this.collapseableGroupRef}>
        {childrenWithProps}
      </div>
    );
  }
}

CollapseableGroup.defaultProps = {
  behaviour: 'accordian',
  activeIndex: 1
};

export default windowResize(CollapseableGroup);
